import { FC } from 'react';
import { View } from 'react-big-calendar';
import { useTranslation } from 'react-i18next';

import cs from 'classnames';

import { InterviewSchedulerView } from 'constants/enums';

import styles from './ViewSwitcher.module.scss';

interface ViewSwitcherProps {
  view: View;
  onView: (view: View) => void;
  isMobile?: boolean;
}

const ViewSwitcher: FC<ViewSwitcherProps> = ({
  view,
  onView,
  isMobile = false
}) => {
  const { t } = useTranslation();
  const firstView = isMobile
    ? InterviewSchedulerView.Day
    : InterviewSchedulerView.Week;
  const firstLabel = isMobile ? t('calendar.day') : t('calendar.week');

  return (
    <div className={styles.viewSwitcherContainer}>
      <button
        type="button"
        className={cs(styles.viewSwitcherItem, {
          [styles.isActive]: view === firstView
        })}
        onClick={() => onView(firstView)}
      >
        {firstLabel}
      </button>
      <button
        type="button"
        className={cs(styles.viewSwitcherItem, {
          [styles.isActive]: view === InterviewSchedulerView.Month
        })}
        onClick={() => onView(InterviewSchedulerView.Month)}
      >
        {t('calendar.month')}
      </button>
    </div>
  );
};

export default ViewSwitcher;
